import '../src/base';
import '~/app/assets/javascripts/application/sitewide';
import '~/app/assets/javascripts/application/enrolled_courses/new';
